module.exports = __webpack_public_path__ + "static/img/PRINTING PU products discription_deskstop1.6bcdbd95.jpg";